import { getBorderFocusStyles } from '../../getBorderFocusStyles';
export var tableRowStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    var borderFocusStyles = getBorderFocusStyles({
      variables: siteVariables
    });
    return Object.assign({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: v.bodyFontSize,
      height: v.defaultRowHeight,
      color: v.color,
      backgroundColor: v.backgroundColor,
      borderWidth: v.borderWidth,
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderBottomColor: v.rowBorderColor,
      padding: v.rowPadding,
      position: 'relative',
      width: '100%',
      ':hover': {
        color: v.hoverColor,
        backgroundColor: v.backgroundHoverColor,
        borderColor: v.rowBorderHoverColor
      }
    }, borderFocusStyles, p.header && {
      fontSize: v.headerFontSize,
      ':hover': {
        color: v.color,
        backgroundColor: v.backgroundColor
      }
    }, p.compact && {
      height: v.compactRowHeight
    });
  }
};
//# sourceMappingURL=tableRowStyles.js.map
